import React from "react";
import classNames from "classnames";
import BaseRow from "../BaseRow";

export default class SpeedRow extends BaseRow {
	generateSpeedOfTarifs() {
		let classes = this.props.classes;
		let text = this.props.text;
		return this.props.data.map((item, index) => {
			let internetSpeed = 0;
			if (item.hasOwnProperty("internet") && item.internet !== null) {
				internetSpeed = item.internet.speed_in ? item.internet.speed_in : 0;
			}
			let viewInternetSpeed = internetSpeed ? `${internetSpeed} ${text.MBPS}` : "-";
			return (
				<div key={index} className={classes.cell}>
					<div className={classes.cellText}>
						<span className={classes.cellTextValue}>{viewInternetSpeed}</span>
						{internetSpeed != 0 &&
							internetSpeed == this.props.maxSpeedTariff &&
							this.generateHigherSvg()}
					</div>
				</div>
			);
		});
	}

	render() {
		let classes = this.props.classes;
		let columns = {
			2: [classes.rowColNumber2],
			3: [classes.rowColNumber3],
			4: [classes.rowColNumber4],
			5: [classes.rowColNumber5],
			6: [classes.rowColNumber6],
		};
		let style = {
			transform: `translateX(${this.props.moveValue}px)`,
		};

		return (
			<div className={classNames(classes.row, columns[this.props.columns])}>
				<div className={classes.headerCell} style={style}>
					<div className={classes.headerCellText}>{this.props.header}</div>
				</div>
				<div className={classes.cellsWrapper}>{this.generateSpeedOfTarifs()}</div>
			</div>
		);
	}
}
